import { render, staticRenderFns } from "./BillPayFatalError.vue?vue&type=template&id=469660c5&scoped=true&"
import script from "./BillPayFatalError.vue?vue&type=script&lang=js&"
export * from "./BillPayFatalError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "469660c5",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('469660c5')) {
      api.createRecord('469660c5', component.options)
    } else {
      api.reload('469660c5', component.options)
    }
    module.hot.accept("./BillPayFatalError.vue?vue&type=template&id=469660c5&scoped=true&", function () {
      api.rerender('469660c5', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/billpay/BillPayFatalError.vue"
export default component.exports